module.exports = __webpack_public_path__ + "media/images/iconSocialLink__okGreen-34494edbed46f3d4bef61d2eb865e580.png";